import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationPreOnboarding(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.PRE_ONBOARDING, { keyPrefix });

  return t;
}

export default useTranslationPreOnboarding;
